<script>
export default {
    name: "ArrowUp"
}
</script>
<template>
    <svg role="img" aria-label="Arrow Up"  viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.71632 0.713676L6 7.15493e-08L5.28368 0.710531L0.719493 5.23782L9.59775e-08 5.95149L1.43582 7.37256L2.15214 6.66203L4.98574 3.85134L4.98574 12.9939L4.98574 14L7.01426 14L7.01426 12.9939L7.01426 3.85448L9.84786 6.66517L10.5642 7.37256L12 5.95149L11.2837 5.24096L6.71949 0.713676L6.71632 0.713676Z" fill="#315A62"/>
    </svg>
</template>
